<template>
  <!-- 包材 -->
  <div>
    <Search ref="search" @on-search="onSearch" @on-reset="onReset" />

    <SearchType
      ref="searchType"
      class="search-Type"
      :data="searchTypeData"
      @change-list="changeList"
      @on-reset="onReset"
    />

    <div class="sample-list" v-loading="tableLoading">
      <SortFilterBtn
        ref="sortFilterBtn"
        :showBtnList="['xp', 'jg']"
        @change-list="sortChangeList"
      />
      <GoodBox :GoodData="tableData.list" />
      <vxe-pager
        background
        size="small"
        :current-page="tableParam.pageNo"
        :page-size="tableParam.pageSize"
        :total="tableData.total"
        :page-sizes="[10, 20, 50]"
        :layouts="layouts"
        @page-change="handlePageChange"
      >
      </vxe-pager>
    </div>
  </div>
</template>
<script>
import GoodBox from '@/components/GoodBox';
import SearchType from './SearchType';
import Search from './Search';
import SortFilterBtn from '@/components/SortFilterBtn';

export default {
  components: { Search, SearchType, GoodBox, SortFilterBtn },
  props: {},
  data() {
    const allDictListData = this.$store.getters.allDictListData.data;
    return {
      searchVal: '',
      tableParam: {
        pageNo: 1,
        pageSize: 10,
        data: {
          keyWords: '',
          classificationList: [],
          formList: [],
          capacityStart: '',
          capacityEnd: '',
        },
      },
      layouts: [
        'PrevPage',
        'JumpNumber',
        'NextPage',
        'FullJump',
        'Sizes',
        'Total',
      ],
      searchTypeData: [
        {
          label: '包材用途',
          name: 'bcytActiveName',
          list: allDictListData.cml_packingmaterial_useclassification,
          tag: 'CheckboxGroup',
        },
        {
          label: '包材形式',
          name: 'bcxsActiveName',
          list: allDictListData.cml_packingmaterial_form,
          tag: 'CheckboxGroup',
        },
        {
          label: '包材容量',
          name: 'bcrlActiveName',
          tag: 'CapacityCheckBox',
        },
      ],
      tableData: {},
      tableLoading: false,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.tableLoading = true;
      this.$http.sampleApply
        .getPackingMaterialListPage(this.tableParam)
        .then(result => {
          this.tableData = result.data;
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    handlePageChange({ currentPage, pageSize }) {
      this.tableParam.pageNo = currentPage;
      this.tableParam.pageSize = pageSize;
      this.getList();
    },
    inputChange(val) {
      this.tableParam.data.keyWords = val;
    },
    onSearch(val) {
      this.tableParam.data.keyWords = val;
      this.tableParam.pageNo = 1;
      this.getList();
    },
    changeList(val, name) {
      let data = this.tableParam.data;
      data.keyWords = this.$refs.search.value;
      if (name === 'bcytActiveName') {
        data.classificationList = val;
      }
      if (name === 'bcxsActiveName') {
        data.formList = val;
      }
      if (name === 'bcrlActiveName') {
        const [capacityStart, capacityEnd] = val;
        data.capacityStart = capacityStart;
        data.capacityEnd = capacityEnd;
      }
      this.getList();
    },
    sortChangeList(name, val) {
      let data = this.tableParam.data;
      delete data.newSort;
      delete data.priceSort;
      delete data.capacitySort;
      data[name] = val;
      this.getList();
    },
    onReset() {
      let data = this.tableParam.data;
      delete data.newSort;
      delete data.priceSort;
      delete data.capacitySort;
      data.classificationList = [];
      data.formList = [];
      data.capacityStart = undefined;
      data.capacityEnd = undefined;
      this.searchTypeData.map(item => {
        this.$refs.searchType.$refs[item.name][0].onReset();
      });
      this.$refs.sortFilterBtn.onReset();
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .sample-list {
  max-width: 1170px;
  .el-tabs__item {
    height: 30px;
    line-height: 30px;
    padding: 0 10px;
  }
  .el-tabs__nav {
    height: 30px;
  }
  #tab-jg {
    padding-left: 10px !important;
  }
  #tab-rl {
    padding-right: 10px !important;
  }
}
.search-Type {
  border: 1px solid #ddd;
  padding: 0 10px 5px 10px;
}
</style>
